import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthSigninRoutingModule } from './auth-signin-routing.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared/shared.module';
import { PlainToolbarModule } from '../plain-toolbar/plain-toolbar.module';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

import { AuthSigninComponent } from './auth-signin/auth-signin.component';
import { AuthSigninFormComponent } from './auth-signin-form/auth-signin-form.component';

@NgModule({
  declarations: [
    AuthSigninComponent,
    AuthSigninFormComponent
  ],
  imports: [
    CommonModule,
    AuthSigninRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    SharedModule,
    PlainToolbarModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
  ]
})
export class AuthSigninModule { }
